// Call state enum
export enum CallState {
  IDLE = 'idle', // Nothing
  PLACING = 'placing', // We are trying to place a call with the device
  RINGING = 'ringing', // The call is ringing
  IN_PROGRESS = 'in_progress',
  ACCEPTED = 'accepted',
  ENDED = 'ended',
  REJECTED = 'rejected', // Tablet user declined the call
}

// Base WebSocket message interface
interface WebSocketMessage {
  action: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface CallSdpMessage extends WebSocketMessage {
  body?: {
    sdpDetails?: {
      type: 'offer' | 'answer' | 'pranswer' | 'rollback';
      value: string;
    };
  };
}

// Call in progress message
export interface CallInProgressMessage extends CallSdpMessage {
  action: 'callInProgress';
}

// Call accepted message
export interface CallAcceptedMessage extends CallSdpMessage {
  action: 'callAccepted';
}

// Tablet: tablet accepted the call
export interface TabletAnswerMessage extends WebSocketMessage {
  action: 'answer';
  answer: {
    sdp: string;
  };
}
